const toBinary = (n: number): string => {
	return (n >>> 0).toString(2)
}

const toBinaryPadded = (nMask: number): string => {
	// nMask must be between -2147483648 and 2147483647
	if (nMask > 2 ** 31 - 1) {
		throw new Error("number too large. number shouldn't be > 2**31-1")
	}

	if (nMask < -1 * 2 ** 31) {
		throw new Error("number too far negative, number shouldn't be < -(2**31)")
	}

	for (
		var nFlag = 0, nShifted = nMask, sMask = '';
		nFlag < 32;
		nFlag++, sMask += String(nShifted >>> 31), nShifted <<= 1
	);

	// sMask = sMask.replace(/\B(?=(.{8})+(?!.))/g, ' ');

	return sMask
}

const getBit = (n: number, bitIndex: number): number => {
	const bitMask = 1 << bitIndex
	const result = n & bitMask
	return result >>> bitIndex
}

const setBit = (n: number, bitIndex: number): number => {
	const bitMask = 1 << bitIndex
	return n | bitMask
}

const clearBit = (n: number, bitIndex: number): number => {
	const bitMask = ~(1 << bitIndex)
	return n & bitMask
}

export { toBinary, toBinaryPadded, getBit, setBit, clearBit }
